export var EAssetType;
(function (EAssetType) {
    EAssetType["Splash"] = "splash";
    EAssetType["Image"] = "image";
    EAssetType["Other"] = "other";
    EAssetType["CardImage"] = "card-image";
    EAssetType["CardIcon"] = "card-icon";
    EAssetType["CardHeader"] = "card-header";
    EAssetType["DocTemplate"] = "doc-template";
})(EAssetType || (EAssetType = {}));
export var EAssetRegion;
(function (EAssetRegion) {
    EAssetRegion["Flanders"] = "V";
    EAssetRegion["Wallonia"] = "W";
    EAssetRegion["Brussels"] = "B";
})(EAssetRegion || (EAssetRegion = {}));
